<template>
  <div class="container-fluid">
    <div
      v-if="isLoading"
      class="text-center mt-5"
    >
      <div
        class="spinner-border text-primary"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>
      <p class="mt-2">
        Loading preview data...
      </p>
    </div>

    <div
      v-else-if="error"
      class="text-center p-5"
    >
      <div class="alert alert-danger">
        {{ error }}
      </div>
    </div>

    <div
      v-else-if="previews.length"
      class="row"
    >
      <div class="col-md-8">
        <div>
          <div class="card custom-block mt-3">
            <div class="card-body d-flex justify-content-between">
              <div class="align-items-center">
                <h3 class="card-title">
                  Name: {{ creative.name }}
                </h3>
                <h4 class="card-subtitle mb-2 text-muted">
                  Status: <span :class="walmart.getStatusBadge(creative.status)">
                    {{ creative.status }}
                  </span>
                </h4>
              </div>
            </div>
          </div>
          <div>
            <div
              v-for="(preview, index) in previews"
              :key="index"
              class="mt-3 mb-2 border rounded custom-block p-3"
            >
              <h3>{{ adUnitTypes[preview.name] }}</h3>
              <img
                :src="`data:image/jpeg;base64,${preview.image}`"
                :alt="preview.name || 'Preview'"
                class="img-fluid"
              >
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card custom-block mt-3">
          <div class="card-body">
            <div class="d-flex justify-content-between">
              <h4 class="card-title">
                Actions
              </h4>
              <a
                v-if="!userId"
                href="/login"
                class="text-right d-inline-block login-proof"
              >
                Login
              </a>
            </div>
            <div class="mt-3">
              <button
                class="btn btn-outline-secondary btn-block"
                @click="copyShareLink"
              >
                <i class="fas fa-link mr-1" />
                Copy Share Link
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="text-center p-5"
    >
      <div class="alert alert-warning">
        No previews available for this creative.
      </div>
    </div>
  </div>
</template>

<script>
import * as walmart from '@frontend/components/helpers/walmart-helpers.js';
import { adUnitTypes } from '@frontend/constants/walmart-constants.js';

export default {
    name: 'WalmartPreviewShare',
    props: {
        token: {
            type: String,
            required: true
        },
        userId: {
            type: Number,
            required: false,
            default: null
        }
    },
    data() {
        return {
            walmart,
            adUnitTypes,
            previews: [],
            creative: {},
            isLoading: true,
            error: null
        }
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        async fetchData() {
            try {
                this.isLoading = true;
                this.error = null;

                const { data } = await axios.post('/walmart/fetch-shared-preview', {
                    token: this.token
                });

                if (data.status === 'error') {
                    this.error = data.message || 'Failed to load preview data';
                    return;
                }

                this.previews = data.previews || [];
                this.creative = data.creative || {};

            } catch (error) {
                console.error('Error fetching preview data:', error);
                this.error = 'An error occurred while loading the preview data';
            } finally {
                this.isLoading = false;
            }
        },

        copyShareLink() {
            const shareLink = window.location.href;
            navigator.clipboard.writeText(shareLink);

            toastr.success('Share link copied');
        }
    }
}
</script>

<style scoped>
.custom-block {
    background-color: #f8fafc;
}
</style>
